
import React, { useContext } from "react";
import { Avatar, Box, Step, StepLabel, Stepper, Typography } from "@mui/material";
import { LocationOn, TripOrigin } from "@material-ui/icons";
import { AirlineStops } from "@mui/icons-material";
import { TaxiBookingContext } from "./BookTaxiContext";
import { serializeAddress, serializePickupTime } from "./BookTaxiUtilities";


export default function BookTaxiHeader(){

    const taxiBookingContext = useContext(TaxiBookingContext);

    const {
        bookingData:{
            pickupTime,
            from,
            vias=[],
            to
        }
    } = taxiBookingContext;

    function TravelModeIcon (props){
        const { icon } = props;

        return(
            <div>
                <Avatar >{icon}</Avatar>
            </div>
        );
    }
    

    return (
        <Box>
            <Typography sx={{textAlign:'center'}}>{serializePickupTime(pickupTime)}</Typography>
            <Stepper className="taxiBookingStepper" alternativeLabel>
                <Step key="from" >
                    <StepLabel 
                        StepIconProps={{
                            icon: <TripOrigin/>,
                        }}
                        StepIconComponent={TravelModeIcon} 
                    >
                        {serializeAddress(from.data)}
                    </StepLabel>
                </Step>
                {vias.map((via,index)=>(
                        <Step key={index}>
                             <StepLabel 
                                StepIconProps={{
                                    icon: <AirlineStops/>,
                                }}
                                StepIconComponent={TravelModeIcon} 
                            >
                                {serializeAddress(via.data)}
                            </StepLabel>
                        </Step>        
                ))}
                <Step key="to">
                    <StepLabel 
                        StepIconProps={{
                            icon: <LocationOn/>,
                        }}
                        StepIconComponent={TravelModeIcon} 
                    >
                        {serializeAddress(to.data)}
                    </StepLabel>
                </Step>
            </Stepper>
        </Box>
    );

}